import { Component, Prop, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import usersStore from '@/store/users';
import { User as ApplicationUser } from '@/models';
import CardComponent from '@/components/CardComponent';
import ListToolbar from '@/components/ListToolbar';
import { Guid } from '@/types';

@Component({
    components: { CardComponent, ListToolbar },
})
export default class Users extends Vue {

    private pageNumber = 1;
    private selected: ApplicationUser | null = null;

    get pageSize(): number {
        return appStore.pageSize;
    }

    get total(): number {
        return usersStore.total;
    }

    get users(): ApplicationUser[] | undefined {
        return usersStore.users;
    }

    get loading(): boolean {
        return appStore.isLoading;
    }

    get canRemove(): boolean {
        return !!this.selected;
    }

    get canEdit(): boolean {
        return !!this.selected;
    }

    private async created() {
        await this.refresh();
    }

    private async mounted() {
        await appStore.activateMenuById({ rootId: 400, subMenuId: 401 });
    }

    private async addUser() {
        await this.$router.push({ name: 'user', params: { id: Guid.Empty } });
    }

    private async deleteUser() {
        if (!this.selected) { return; }

        const selectedId: string = this.selected.id;

        this.$buefy.dialog.confirm({
            title: 'Eliminazione utente',
            message: 'Sei sicuro/a di voler <b>rimuovere</b> l\'utente selezionato?',
            confirmText: 'Conferma',
            cancelText: 'Annulla',
            type: 'is-warning',
            hasIcon: true,
            onConfirm: async () => {
                await usersStore.deleteUserAsync({ id: selectedId });
            },
        });
    }

    private select(row: ApplicationUser, oldRow: ApplicationUser | null): void {
        this.selected = row;
    }

    private async editUser(user: ApplicationUser) {

        const selectedId: string = user ? user.id : (this.selected as ApplicationUser).id;

        await this.$router.push({ name: 'user', params: { id: selectedId } });
    }

    private async refresh() {
        this.pageNumber = 1;
        await usersStore.fetchUsersAsync({ pageNumber: this.pageNumber, pageSize: this.pageSize });
    }

    private async onPageChange(page: number) {
        this.pageNumber = page;
        await usersStore.fetchUsersAsync({ pageNumber: this.pageNumber, pageSize: this.pageSize });
    }
}